import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

export class UtilService {
  constructor(@Inject(DOCUMENT) private document: any) {}

  generateSecureRandom(min: number, max: number): number {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    const randomValue = array[0] / (0xffffffff + 1);
    return Math.floor(randomValue * (max - min + 1)) + min;
  }

  static AGM_KEY = 'AIzaSyAi4afReKBDwzPdTpYj9W9lucbIExG4rI';
}
